import React from 'react';
import sprintf from 'sprintf';
import moment from 'moment';

class SMMustHeaderView extends React.Component {

  constructor(props) {
    super(props);
    const promotions = this.props.promotions;
    if (!promotions || promotions.length == 0) return null;
    this.state = {
      promotionIndex: Math.floor(Math.random() * promotions.length)
    };
  }

  componentDidMount() {
  }

  render() {
    const promotions = this.props.promotions;
    if (!promotions || promotions.length == 0) return null;
    const promotion = promotions[this.state.promotionIndex];
    const backgroundImage = promotion.background_image ? sprintf('url(%s)', promotion.background_image) : 'none';
    let startedAt = moment(promotion.started_at).utc();
    let endedAt = moment(promotion.ended_at).utc();

    return(
      <a href={Routes.promotion_path(promotion)} className="site-header__campaign"
        style={{color:promotion.text_color, backgroundColor:promotion.background_color, backgroundImage:backgroundImage, backgroundRepeat: 'repeat'}}>
        <div className="site-header__campaign-date-box">
          <div className="site-header__campaign-date-box-inner">
            {(()=>{
              if (promotion.first_limited){
                if (promotion.coupon_valid_at_for_user && promotion.coupon_expires_at_for_user) {
                  startedAt = moment(promotion.coupon_valid_at_for_user).utc();
                endedAt = moment(promotion.coupon_expires_at_for_user).utc();
                return(
                  <p className="site-header__campaign-date">{moment(endedAt).format("YYYY年")}<br />{moment(endedAt).format("M月D日")}<br />まで</p>
                );
              } else {
                return(
                  <p className="site-header__campaign-date">新規登録<br />から<br />1ヶ月有効</p>
                );
              }
            } else {
              return (
                <p className="site-header__campaign-date">{moment(endedAt).format("YYYY年")}<br />{moment(endedAt).format("M月D日")}<br />まで</p>
              );
            }
          })()}
          </div>
        </div>
        <p className="site-header__campaign-title">{promotion.title}</p>
        <div className="site-header__campaign-button-box">
          <div style={{color:promotion.link_color}} className="button-white site-header__campaign-button">キャンペーン詳細へ</div>
        </div>
      </a>
    );
  }

}
export default SMMustHeaderView;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMMustHeaderView.jsx